import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  ShareLinkDialogComponent,
  IShareLinkDialogData
} from './share-link-dialog.component';

/**
 * Helper function to open the Share Link Configuration Dialog.
 *
 * @param dialog Angular MatDialog service instance.
 * @param data Target artifact metadata (artifactId, fileName, category).
 * @returns MatDialogRef instance.
 */
export function openShareLinkDialog(
  dialog: MatDialog,
  data: IShareLinkDialogData
): MatDialogRef<ShareLinkDialogComponent> {
  return dialog.open(ShareLinkDialogComponent, {
    data,
    width: '560px',
    maxWidth: '95vw',
    panelClass: 'share-link-dialog-panel',
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-dark-backdrop',
    autoFocus: false,
    disableClose: false
  });
}
